import React from "react";
import Slider from "react-slick";
class Images extends React.Component {

    componentDidMount() {
        console.log(this.props);
    }

    render() {
        const settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 1,
            slidesToScroll: 1
        };
        return (
          <section className="rob-slider">
              <div className="container">
                  <div className="row">
                      <div className="offset-md-1 col-md-10">
                  <Slider {...settings}>
                      {this.props.images.map(function (name, index) {

                          return  <div key={index} ><div className={'rob-slider--wrapper'}>
                          <img alt="" src={name.url} className={'rob-slider--slide'} />
                          </div> </div>
                      })
                      }

                  </Slider>
              </div>
                  </div>
              </div>
          </section>
        );

    }

}

export default Images;




// WEBPACK FOOTER //
// ./src/components/elements/blockLoop/Images.js